/**
 * @file FAQのAnswerトグル動作
 *
 */
'use strict';

/**
 * @classname ToggleFAQAnswerView
 * @classdesc FAQのAnswerトグル動作
 */
export default class ToggleFAQAnswerView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ToggleFAQAnswerView.constructor');
		this._$e = $e;
		this._$faq__answer = this._$e
			.closest('.faq-wrap')
			.find('.faq__answer-wrapper');
		this._$icon = this._$e.closest('.faq-wrap').find('.fa-angle-down');
		this._$e.on('click', () => this.onClick());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof ToggleFAQAnswerView
	 * @return {undefined}
	 */
	onClick() {
		console.log('ToggleFAQAnswerView.onClick');
		this._$faq__answer.slideToggle();
		this._$icon.toggleClass('rotate');
	}
}
